import React from 'react';
import { Grid, Typography, Box, CircularProgress } from '@mui/material';
import FlavorCard from './FlavorCard';
import { Flavor } from '../../utils/filterUtils';

interface FlavorGridProps {
  flavors: Flavor[];
  loading: boolean;
  error: string | null;
  checkIsFavorite: (flavorId: string) => boolean;
  checkHasTried: (flavorId: string) => boolean;
  getFlavorRating: (flavorId: string) => number | null;
  getFlavorNote: (flavorId: string) => string | null;
  onAddToFavorites: (flavorId: string) => void;
  onRemoveFromFavorites: (flavorId: string) => void;
  onMarkAsTried: (flavorId: string) => void;
  onRateFlavor: (flavorId: string, rating: number) => void;
  onSaveNote: (flavorId: string, note: string) => void;
}

const FlavorGrid: React.FC<FlavorGridProps> = ({
  flavors,
  loading,
  error,
  checkIsFavorite,
  checkHasTried,
  getFlavorRating,
  getFlavorNote,
  onAddToFavorites,
  onRemoveFromFavorites,
  onMarkAsTried,
  onRateFlavor,
  onSaveNote
}) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  if (flavors.length === 0) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography>No flavors found matching your criteria.</Typography>
      </Box>
    );
  }

  return (
          <Grid container spacing={4}>
            {flavors.map((flavor) => (
              <Grid item key={flavor.id} xs={12} sm={6} md={4}>
          <FlavorCard
            flavor={flavor}
            isFavorite={checkIsFavorite(flavor.id)}
            hasTried={checkHasTried(flavor.id)}
            userRating={getFlavorRating(flavor.id)}
            userNote={getFlavorNote(flavor.id)}
            onAddToFavorites={onAddToFavorites}
            onRemoveFromFavorites={onRemoveFromFavorites}
            onMarkAsTried={onMarkAsTried}
            onRateFlavor={onRateFlavor}
            onSaveNote={onSaveNote}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default FlavorGrid;
